import { render, staticRenderFns } from "./AddComPartner.vue?vue&type=template&id=2fceb51b&scoped=true&"
import script from "./AddComPartner.vue?vue&type=script&lang=js&"
export * from "./AddComPartner.vue?vue&type=script&lang=js&"
import style0 from "./AddComPartner.vue?vue&type=style&index=0&id=2fceb51b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fceb51b",
  null
  
)

export default component.exports